"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Hand = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Hand_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 13,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 8.74c0 .199-.085.369-.255.539-.425.34-.765.652-1.048.936-.821.794-1.558 1.73-2.266 2.892A5.985 5.985 0 0 1 6.277 16H6.107C3.813 15.887 2 14.043 2 11.718V4.06c0-.454.34-.851.765-.908a.808.808 0 0 1 .651.227c.17.17.283.397.283.624v4.68c0 .17.114.283.284.283.17 0 .283-.114.283-.284V2.104c0-.454.34-.85.764-.88a.685.685 0 0 1 .652.2c.17.17.283.396.283.623V8.4c0 .17.113.283.283.283.17 0 .284-.113.284-.283V.913c0-.454.34-.85.764-.908a.808.808 0 0 1 .652.227c.17.17.283.397.283.624v7.26c0 .17.113.284.283.284.17 0 .283-.114.283-.284V1.991a.86.86 0 0 1 .284-.624c.17-.17.424-.227.651-.227a.895.895 0 0 1 .765.907V8.74c0 .312.17.567.453.709a.729.729 0 0 0 .821-.113c.935-.823 1.7-1.305 2.181-1.362.538-.056.878.227.991.54.029.028.057.141.057.226Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Hand_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Hand;
exports["default"] = _default;